import type { IndividualDataScope } from './types';

/**
 * マイプロフィール（本人向け画面）を構成する台帳集合の SSoT。
 *
 * これらの台帳のいずれかで `self` データスコープが有効なら、マイプロフィール入口
 * （ユーザーメニュー）・ヘッダータブ・インデックスのリダイレクトを許可する。
 * プロダクト権限 `my-profile` は廃止され、可視性は台帳 self に連動する
 * （backend はコントローラの宣言的 Guard＝`DataScopeSelfGuard` が台帳 self で判定する）。
 *
 * 対象台帳の増減はこの配列の一箇所で行う。`Popover`（features）と `MY_PROFILE_TABS`（routes）は
 * 本 SSoT を参照し、台帳集合の定義が複数箇所に分散しないようにする（依存境界も守る）。
 */
export const MY_PROFILE_LEDGERS = ['device', 'account', 'certification'] as const;

/** マイプロフィールを構成する台帳（{@link MY_PROFILE_LEDGERS} の要素）。 */
export type MyProfileLedger = (typeof MY_PROFILE_LEDGERS)[number];

/**
 * 指定台帳の `self` データスコープが有効か（純粋関数）。
 * 本人向け画面のタブ可視性判定（各タブ = 1 台帳）に使う。
 *
 * マイプロフィール入口（いずれかの台帳で self が有効か）の判定は、session を内部で参照する
 * `useCanAccessMyProfile`（`@/lib/auth`）を使う。呼び出し側に dataScopes を抽出させない。
 */
export function hasLedgerSelfScope(dataScopes: ReadonlyArray<IndividualDataScope>, ledger: string): boolean {
  return dataScopes.some(entry => entry.ledger === ledger && entry.scope === 'self');
}